import { ComponentProps, Dispatch, SetStateAction, useCallback } from 'react';

import Flag, { FlagGroup as AkFlagGroup } from '@atlaskit/flag';
import CheckCircleIcon from '@atlaskit/icon/core/check-circle';
import StatusErrorIcon from '@atlaskit/icon/core/status-error';
import { token } from '@atlaskit/tokens';

export type FlagGroupItem = {
  hasError?: boolean;
} & Pick<ComponentProps<typeof Flag>, 'id' | 'description' | 'title'>;

const FlagGroup = ({
  setFlags,
  flags,
}: {
  setFlags: Dispatch<SetStateAction<FlagGroupItem[]>>;
  flags: FlagGroupItem[];
}): JSX.Element => {
  const dismissFlag = useCallback(
    (id: string | number) => {
      setFlags(current => current.filter(flag => flag.id !== id));
    },
    [setFlags]
  );

  return (
    <AkFlagGroup onDismissed={dismissFlag}>
      {flags.map(flag => {
        return (
          <Flag
            id={flag.id}
            icon={
              flag.hasError ? (
                <StatusErrorIcon
                  color={token('color.icon.danger')}
                  label=""
                  spacing="spacious"
                />
              ) : (
                <CheckCircleIcon
                  color={token('color.icon.success')}
                  label=""
                  spacing="spacious"
                />
              )
            }
            key={flag.id}
            title={flag.title}
            description={flag.description}
          />
        );
      })}
    </AkFlagGroup>
  );
};

// eslint-disable-next-line import/no-default-export
export default FlagGroup;
